import React from 'react';
import { Share2, Link2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { forumCanonical } from '../utils/seo';

interface Props {
  forumId: string;
  name: string;
  darkMode: boolean;
}

const ShareForumCard: React.FC<Props> = ({ forumId, name, darkMode }) => {
  const url = forumCanonical(forumId);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link kopyalandı');
    } catch {
      toast.error('Kopyalanamadı');
    }
  };

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: name, url });
        return;
      } catch {
        /* fallback */
      }
    }
    await copy();
  };

  return (
    <div className="flex gap-2">
      <button
        type="button"
        onClick={share}
        className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm border ${
          darkMode ? 'border-gray-600 hover:bg-gray-700' : 'border-gray-200 hover:bg-gray-50'
        }`}
      >
        <Share2 size={16} /> Paylaş
      </button>
      <button
        type="button"
        onClick={copy}
        className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm border ${
          darkMode ? 'border-gray-600 hover:bg-gray-700' : 'border-gray-200 hover:bg-gray-50'
        }`}
      >
        <Link2 size={16} /> Link
      </button>
    </div>
  );
};

export default ShareForumCard;
